import React from 'react';
import { Box, Container, Typography, Button, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';

import VideoBackground from '../../../components/VideoBackground';
import DataTrust from './sections/DataTrust';
import FeatureShowcase from './sections/FeatureShowcase';

const LandingPage = () => {
	const { t } = useTranslation('landing');

	return (
		<div>
			<Box
				id="home"
				component="section"
				sx={{
					position: 'relative', // Required for absolute children
					py: { xs: 8, md: 12 },
					pt: '100px' // Fixed height to accommodate scrolling header
				}}
			>
				{/* CONTENT LAYER - Text and Buttons */}
				<VideoBackground>
					<Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
						<Box sx={{ py: 8, textAlign: 'center' }}>
							<Paper sx={{ padding: '20px' }}>
								<Typography
									variant="h2"
									component="h1"
									gutterBottom
									fontWeight="bold"
									sx={{
										fontSize: { xs: '1.8rem', sm: '2.5rem', md: '3.5rem' },
										lineHeight: 1.2,
										color: 'white'
									}}
								>
									{t('hero.primary')}
									<br />
									<span style={{ color: 'glass.main' }}>
										{t('hero.secondary')}
									</span>
								</Typography>

								<Box sx={{ mt: 3, mb: 6, maxWidth: '800px', mx: 'auto' }}>
									<Typography variant="h5" component="p" color="glass.main">
										{t('hero.description')}
									</Typography>
								</Box>

								<Button
									component="a"
									variant="contained"
									size="large"
									sx={{
										px: 4,
										py: 1.5,
										fontSize: '1.1rem',
										fontWeight: 'bold',
										textTransform: 'none'
									}}
								>
									{t('hero.callToAction')}
								</Button>

								<Box
									sx={{
										display: { xs: 'block', md: 'none' },
										position: 'absolute',
										top: 0,
										left: 0,
										right: 0,
										bottom: 0,
										backgroundImage: "url('/hero-background-fallback.jpg')",
										backgroundSize: 'cover',
										zIndex: -1
									}}
								/>
							</Paper>
						</Box>
					</Container>
				</VideoBackground>
			</Box>
			<DataTrust />
			<FeatureShowcase />
		</div>
	);
};

export default LandingPage;
